export const validateEmail = (value: string) => {
  let error;
  if (!value) {
    error = 'Email address is required';
  } else if (!/^\S+@\S+$/.test(value)) {
    // This is a _very_ simple test for a valid email address, it is
    // just meant to help the user not make a simple mistake when filling
    // out the form - Cognito will do more in depth email address checking.
    error = "The email address doesn't seem valid";
  }
  return error;
};

export const validatePassword = (value: string) => {
  let error;
  if (!value) {
    error = 'Password is required';
  }
  return error;
};

// Mirrors the Cognito user pool's password_policy in terraform/cognito.tf.
// Keep in sync if the policy changes there.
export const NEW_PASSWORD_RULES = {
  minLength: 10,
  requireLowercase: true,
  requireUppercase: true,
  requireNumber: true,
  requireSymbol: true,
};

export const NEW_PASSWORD_HELPER_TEXT =
  'At least 10 characters, with uppercase, lowercase, number, and symbol.';

export const validateNewPassword = (value: string): string | undefined => {
  if (!value) return 'Password is required';
  if (value.length < NEW_PASSWORD_RULES.minLength) {
    return `Password must be at least ${NEW_PASSWORD_RULES.minLength} characters`;
  }
  if (NEW_PASSWORD_RULES.requireLowercase && !/[a-z]/.test(value)) {
    return 'Password must contain a lowercase letter';
  }
  if (NEW_PASSWORD_RULES.requireUppercase && !/[A-Z]/.test(value)) {
    return 'Password must contain an uppercase letter';
  }
  if (NEW_PASSWORD_RULES.requireNumber && !/[0-9]/.test(value)) {
    return 'Password must contain a number';
  }
  if (NEW_PASSWORD_RULES.requireSymbol && !/[^a-zA-Z0-9]/.test(value)) {
    return 'Password must contain a symbol';
  }
  return undefined;
};

export const validateCode = (value: string) => {
  let error;
  if (!value) {
    error = 'Code is required';
  }
  return error;
};
